import * as React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import "./styles.css";

class CampaignSetup extends React.Component {

  constructor(props) {
    super(props);
    this.state = {value: 'sandbox'};

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    alert('You selected: ' + this.state.value);
    console.log(this.state.value)
    event.preventDefault();
  }

  render() {
    return (
      <div className = "App">
        <div>
        <div style={{marginTop:20}}></div>
          <Grid
              container
              direction="column"
              alignItems="center"
              >
              <FormControl onSubmit={() => this.state.value.name}>
              <FormLabel component="legend"></FormLabel>
              <RadioGroup
                  aria-label="campaign-setup"
                  name="campaign-setup"
                  value={this.state.value}
                  onChange={this.handleChange}
              >
                  <FormControlLabel id="sandbox" name="sandbox" value="sandbox" control={<Radio />} label="Sandbox" />
                  <FormControlLabel id="production" name="production" value="production" control={<Radio />} label="Production" />
                  <FormControlLabel id="staging" name="staging" value="staging" control={<Radio />} label="Staging" />

                  {console.log(this.state.value)}
              </RadioGroup>
              </FormControl>
          </Grid>
          <div style={{marginBottom:20}}></div>
        </div>
      </div>
    );
  }
}

export default CampaignSetup;